import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "min-w-0 w-full" }, [
    _c(
      "div",
      [
        _c(
          VRow,
          { staticClass: "justify-center", attrs: { dense: "" } },
          _vm._l(_vm.cards, function (card) {
            return _c(
              VCol,
              {
                key: card.title_en,
                staticClass: "pr-3 pl-3 mb-6",
                attrs: { cols: "12", md: card.flex, sm: 6 },
              },
              [
                _c(VHover, {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var hover = ref.hover
                          return [
                            _c(
                              VCard,
                              {
                                staticClass:
                                  "d-flex align-center justify-center",
                                attrs: {
                                  disabled: !card.access,
                                  color: card.color,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleClick(card)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex text-center justify-center",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {},
                                      [
                                        card.image
                                          ? _c(VImg, {
                                              class: {
                                                "disabled-card": !card.access,
                                              },
                                              attrs: {
                                                "max-width": "156px",
                                                width: "156px",
                                                ratio: "1",
                                                src: require("../../assets/icons/" +
                                                  card.image),
                                              },
                                            })
                                          : _c(VImg, {
                                              attrs: {
                                                "max-width": "156px",
                                                width: "156px",
                                                src: card.urlImage,
                                              },
                                            }),
                                        _c(
                                          VCardTitle,
                                          {
                                            staticClass:
                                              "headline m-0 p-0 text-center justify-center align-center pl-3 pr-3 mb-2",
                                            staticStyle: {
                                              "font-size": "1.3rem!important",
                                            },
                                          },
                                          [
                                            _vm.idioma == "es"
                                              ? _c("div", [
                                                  _vm._v(_vm._s(card.title_es)),
                                                ])
                                              : _c("div", [
                                                  _vm._v(_vm._s(card.title_en)),
                                                ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                card.subtitle_en
                                  ? _c(VExpandTransition, [
                                      hover
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex transition-fast-in-fast-out darken-2 v-card--reveal white--text rounded-lg",
                                              staticStyle: { height: "100%" },
                                            },
                                            [
                                              _c(
                                                VRow,
                                                {
                                                  staticStyle: {
                                                    margin: "0 1px 0 1px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    VCol,
                                                    {
                                                      staticClass:
                                                        "font-weight-regular",
                                                      staticStyle: {
                                                        "font-size": "0.8em",
                                                        "line-height": "1.2",
                                                        "word-break":
                                                          "break-word",
                                                        "text-align": "justify",
                                                      },
                                                      attrs: { cols: "12" },
                                                    },
                                                    [
                                                      _vm.idioma == "es"
                                                        ? _c("div", [
                                                            _vm._v(
                                                              _vm._s(
                                                                card.subtitle_es
                                                              )
                                                            ),
                                                          ])
                                                        : _c("div", [
                                                            _vm._v(
                                                              _vm._s(
                                                                card.subtitle_en
                                                              )
                                                            ),
                                                          ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    VCol,
                                                    {
                                                      staticClass:
                                                        "icon-absolute",
                                                    },
                                                    [
                                                      _c(
                                                        VIcon,
                                                        {
                                                          attrs: {
                                                            medium: "",
                                                            color: "white",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " mdi-check-circle-outline "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ],
              1
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }